import React from 'react'
import {PageTitle} from '../../Molecules/BaseMembersPages/PageTitle'
import {ContentBlock} from '../../Molecules/BaseContentBlocks/ContentBlock'
import {ContentTitle} from '../../Molecules/BaseContentBlocks/ContentTitle'
import {ContentTopMessage} from '../../Molecules/BaseContentBlocks/ContentTopMessage'

function Members404Page(): JSX.Element {
  return (
    <>
      <PageTitle>ご案内</PageTitle>
      <ContentBlock>
        <ContentTitle>お探しのページが見つかりません</ContentTitle>
        <ContentTopMessage>URLをご確認ください。</ContentTopMessage>
      </ContentBlock>
    </>
  )
}

export default Members404Page
